import React, {useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {List} from 'immutable';
import './CallCardTabs.sass';
import {ActivityTabContent} from '@components/call-card/ActivityTabContent';
import {UserCallActivity} from '@store/call-card/UserCallActivity';
import {Call} from '@store/call-card/Call';
import CallCardDetailsDialogContainer from 'components/pure/call-card/CallCardDetailsDialogContainer';
import FullScreenScorecardContainer from 'components/pure/scorecards/FullScreenScorecardContainer';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {LibraryTabContent} from '@components/call-card/LibraryTabContent';
import {TagData} from 'stores/files/FileUploadStore';
import {Library} from '@store/@types/records/Library';
import User from 'records/User';
import {UserComment} from 'records/UserComment';
import {CallCardSummary} from '@components/call-card/CallCardSummary';

enum TABS {
  SUMMARY = 'SUMMARY',
  SCORECARD = 'SCORECARD',
  ACTIVITY = 'ACTIVITY',
  DETAILS = 'DETAILS',
  TAGS_LIBRARY = 'TAGS_LIBRARY',
}

interface CallCardTabsProps {
  scorecards: List<any>;
  userActivities: List<UserCallActivity>;
  call: Call;
  location: RouterLocation;
  libraries: Library[];
  tags: List<TagData>;
  sessionUser: User;
  comments: List<UserComment>;
}

export const CallCardTabs: React.FC<CallCardTabsProps> = props => {
  const summaryExists =
    props.call.rawFields.get('Summary') ||
    props.call.rawFields.get('Next Steps') ||
    props.call.rawFields.get('Questions Answers');
  const [activeTab, setActiveTab] = useState(summaryExists ? TABS.SUMMARY : TABS.SCORECARD);
  return (
    <div className="call-card-tabs">
      <Tabs
        className="tab-list"
        indicatorColor="primary"
        value={activeTab}
        onChange={(e, tab) => setActiveTab(tab)}>
        {summaryExists && <Tab label="Call Summary" value={TABS.SUMMARY} />}
        <Tab label="Scorecard" value={TABS.SCORECARD} />
        <Tab label="Activity" value={TABS.ACTIVITY} />
        <Tab label="Details" value={TABS.DETAILS} />
        <Tab label="Tags/Library" value={TABS.TAGS_LIBRARY} />
      </Tabs>
      {getTabContent(activeTab, props)}
    </div>
  );
};

function getTabContent(tab: TABS, props: CallCardTabsProps) {
  switch (tab) {
    case TABS.SUMMARY:
      return <CallCardSummary gpt={props.call.gpt} />;
    case TABS.SCORECARD:
      return (
        <FullScreenScorecardContainer
          newCallCard
          location={props.location}
          fileUploadId={props.call.id}
        />
      );
    case TABS.ACTIVITY:
      return <ActivityTabContent activities={props.userActivities} callId={props.call.id} />;
    case TABS.DETAILS:
      return (
        <CallCardDetailsDialogContainer
          newCallCard
          useDialog={false}
          call={props.call}
          onTouchTapCloseButton={() => null}
          fileUploadId={props.call.id}
          template={props.call.template}
          caller={props.call.caller}
        />
      );
    case TABS.TAGS_LIBRARY:
      return (
        <LibraryTabContent
          sessionUser={props.sessionUser}
          libraries={props.libraries}
          tags={props.tags}
          callId={props.call.id}
          userHighlights={props.comments.filter(c => c.isRange())}
        />
      );
  }
}
